"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PostOfficeModel = /** @class */ (function () {
    function PostOfficeModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/post-office",
            UPDATE: APPURL + "/api/v1/post-office",
            CREATE: APPURL + "/api/v1/post-office",
        };
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    PostOfficeModel.prototype.extract = function (result) {
        return result.data;
    };
    PostOfficeModel.prototype.cacheResults = function (result) {
        return this.extract(result);
    };
    PostOfficeModel.prototype.getSenders = function (email) {
        return this.$http
            .get(this.APPURL + "/api/v1/post-office/senders?sender=" + email)
            .then(this.cacheResults);
    };
    return PostOfficeModel;
}());
PostOfficeModel.$inject = ["$http", "APPURL"];
exports.default = PostOfficeModel;
